import { SelectControl as WPSelectControl } from '@wordpress/components';

const SelectControl = ({ field, value, onChange }) => {
    return (
        <WPSelectControl
            label={field.label}
            value={value}
            options={field.options || []}
            onChange={onChange}
            __next40pxDefaultSize
            __nextHasNoMarginBottom
        />
    );
};

export default SelectControl;